import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import messages from '../../../messages/ru.json';
import Home from '../home';

const HomeRu = (props) => <Home messages={messages} />;

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HomeRu);
